const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// Limpieza: la talla guardada (footSize) ya no se usa. Se borra para los visitantes que la tenían.
try { localStorage.removeItem('footSize'); } catch (e) {}
